import { render, staticRenderFns } from "./panel_resizer.vue.js?vue&type=template&id=0fa10046!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_resizer.vue?vue&type=template&id=0fa10046"
import script from "./panel_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_resizer.vue?vue&type=script&lang=js"
export * from "./panel_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa10046')) {
      api.createRecord('0fa10046', component.options)
    } else {
      api.reload('0fa10046', component.options)
    }
    module.hot.accept("./panel_resizer.vue.js?vue&type=template&id=0fa10046!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_resizer.vue?vue&type=template&id=0fa10046", function () {
      api.rerender('0fa10046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/panel_resizer.vue"
export default component.exports